import { createIcon } from './create-icon';

export const ChevronUpIcon = createIcon('ChevronUpIcon', <path d="M18 15l-6-6-6 6" />);
